<div fxLayout="row" fxLayoutAlign="start center" style="height: 40px; margin-top: 3px" >
    <mat-icon [ngClass]="statusClass$ | async" [icIcon]="baselineFiberManualRecord"></mat-icon>
</div>
